import { render, staticRenderFns } from "./FacebookBadgesIcon.vue?vue&type=template&id=2cdbbf9a&"
import script from "./FacebookBadgesIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookBadgesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports